import * as React from "react";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import thLocale from "date-fns/locale/th";
import { FormLabel, InputBase, Paper } from "@mui/material";
import { green, red } from "@mui/material/colors";
import { ReDate } from "./../../_source/Datefn";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { fontSize } from "@mui/system";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiSvgIcon-root": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 13.5,
    padding: "5px 26px 5px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: ['"Customfont"'].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "none",
      // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}));
const useStyles = makeStyles({
  inputgroupaddon: {
    // height: "22px",
    maxHeight: "22px",
    minWidth: "20px",
    width: "100px",
    padding: "2px",
    fontsize: "15px",
    fontWeight: "700",
    lineHeight: "1",
    color: "#555",
    textAlign: "center",
    backgroundColor: "#eee",
    border: "1px solid #ccc",
    borderRadius: "4px",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    display: "table-cell",
    borderCollapse: "separate",
  },
  inputgroupaddon1: {
    // height: "22px",
    maxHeight: "22px",
    minWidth: "150px",
    width: "100px",
    padding: "2px",
    fontSize: "15px",
    fontWeight: "700",
    lineHeight: "1",
    textAlign: "right",
    borderRadius: "4px",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    display: "table-cell",
    borderCollapse: "separate",
  },
  inputGroup: {
    position: "relative",
    display: "table",
    borderCollapse: "separate",
    float: "none",
    paddingRight: 0,
    paddingLeft: 0,
    marginTop: "2px",
    marginBottom: "3px",
    paddingLeft: "15px",
    paddingRight: "15px",
    width: "100%",
  },
  inputGroupPopup: {
    position: "relative",
    display: "table",
    borderCollapse: "separate",
    float: "left",
    paddingRight: "0px",
    paddingLeft: "0px",
    marginTop: "2px",
    marginBottom: "3px",
    width: "100%",
  },
  LocalizationProvider: {
    "& .MuiInputLabel-root": {
      padding: "1px",
      fontsize: "0px",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "12px",
    },
    "& .MuiInputLabel-root": {
      border: "0",
      borderColor: red,
    },
  },
  LocalizationProviderpopup: {
    "& .MuiInputLabel-root": {
      padding: "1px",
      fontsize: "0px",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "12px",
    },
    "& .MuiInputLabel-root": {
      border: "0",
      borderColor: red,
    },
  },
  input: {
    "& .MuiOutlinedInput-input": {
      padding: "1px",
      fontSize: "14px",
      fontFamily: "Customfont",
      // height: "15px !important",
    },
    "& .MuiInputBase-root": {
      marginTop: "-5px",
    },
    "& .Mui-focused": {
      color: "#00000",
    },
    "& .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "0px !important",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "18px",
    },
  },
  hiddenlabal1: { padding: "0px", width: "80%" },
});
const masklocale = "__/__/____";
export default function MaterialUIPickers(props) {
  const classes = useStyles();
  const { title, defaultdate, open, hiddenlabal, popup } = props;
  const [value, setValue] = React.useState(new Date());
  const [datePickerdisabled, setdatePickerdisabled] = React.useState(false);
  React.useEffect(() => {
    setDefaultDate();
  }, [defaultdate]);

  React.useEffect(() => {
    setdatePickerdisabled(open === 0 ? true : false);
  }, [open]);

  const setDefaultDate = () => {
    let newData;
    if (defaultdate) {
      convertDate(defaultdate, "input");
      let strarr = defaultdate.split("/");
      newData = Number(strarr[2]) - 543 + "-" + strarr[1] + "-" + strarr[0];
    } else if (defaultdate === null) {
      setValue(null);
    } else {
      newData = new Date();
    }
    props.DateValue(defaultdate === null ? null : ReDate(newData));
  };
  const handleChange = (newValue) => {
    setValue(newValue);
    if (newValue === null) {
      props.DateValue(null);
    } else {
      convertDate(newValue, "props");
    }
  };
  const convertDate = async (dateValue, provenance) => {
    let newData;
    try {
      if (provenance === "props") {
        const [month, day, year] = [
          dateValue.getMonth(),
          dateValue.getDate(),
          dateValue.getFullYear(),
        ];
        newData = (await day) + "/" + Number(month + 1) + "/" + (year + 543);
        props.DateValue(newData);
      } else if (provenance === "input") {
        let strarr = dateValue.split("/");
        newData = Number(strarr[2]) - 543 + "-" + strarr[1] + "-" + strarr[0];
        setValue(dateValue !== "" ? Date.parse(newData) : new Date());
      }
    } catch (error) {}
  };
  return (
    <>
      <Paper
        component="form"
        sx={{
          display: "flex",
          width: "100%",
          boxShadow: "none",
        }}
      >
        {hiddenlabal ? (
          <></>
        ) : (
          <FormLabel
            id="demo-radio-buttons-group-label"
            sx={{
              paddingTop: "5px",
              paddingLeft: "3px",
              paddingRight: "3px",
              paddingBottom: "5px",
              color: "#555",
              fontSize: "14px",
              fontWeight: "700",
              border: 1,
              borderTopLeftRadius: 4,
              borderBottomLeftRadius: 4,
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
              lineHeight: 1.8,
              fontFamily: "Customfont !important",
              backgroundColor: "#eee",
              border: "1px solid #ccc",
              minWidth: "100px",
              textAlign: "center",
              minHeight: "30px", // Match form-group input height
              height: "30px",
              display: "flex",
              alignItems: "center",
              boxSizing: "border-box",
              verticalAlign: "middle",
            }}
          >
            {title}
          </FormLabel>
        )}
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          locale={thLocale}
          className={classes.LocalizationProvider}
        >
          <DatePicker
            // label="-"
            disabled={datePickerdisabled}
            mask={masklocale}
            value={value}
            renderInput={(params) => (
              <TextField
                {...params}
                className={classes.input}
                fullWidth={true}
                hiddenLabel
                // variant="standard"
                size="small"
                sx={{
                  marginTop: "5px",
                  lineHeight: 1,
                  height: "30px",
                  "& .MuiInputBase-input": {
                    height: "30px",
                    boxSizing: "border-box",
                    padding: "6px 14px",
                  },
                }}
              />
            )}
            onChange={(e) => handleChange(e)}
          />
        </LocalizationProvider>
      </Paper>
    </>
    // <div className={popup ? classes.inputGroupPopup : classes.inputGroup} style={hiddenlabal ? { padding: "0px", width: "80%" } : {}} >
    //     {!hiddenlabal ? <span className={popup ? classes.inputgroupaddon1 : classes.inputgroupaddon}>{title} </span> : ""}
    //     <LocalizationProvider dateAdapter={AdapterDateFns} locale={thLocale} className={classes.LocalizationProvider} >
    //         <DatePicker
    //             // label="-"
    //             disabled={datePickerdisabled}
    //             mask={masklocale}
    //             value={value}

    //             renderInput={(params) =>
    //                 <TextField {...params} className={classes.input}
    //                     fullWidth={true}
    //                     hiddenLabel
    //                     // variant="standard"
    //                     size="small"

    //                 />}
    //             onChange={e => handleChange(e)}

    //         />
    //     </LocalizationProvider>
    // </div>
  );
}
MaterialUIPickers.propTypes = {
  // You can declare that a prop is a specific JS primitive. By default, these
  // are all optional.
  title: PropTypes.string,
  defaultdate: PropTypes.string,
  open: PropTypes.number,
  hiddenlabal: PropTypes.bool,
  popup: PropTypes.bool,
};
